<template>
<div>
  <section class="page-title">
    <div class="center more-padding">
      <h1 class="the-title" style="font-size: 30px"><span>Você está sendo redirecionado</span> para a área do cliente em {{this.contador}} segundos...</h1>
    </div>
  </section>

  <loading :active.sync="isLoading" :can-cancel="true" color="#446fb5" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import {
  mapState
} from 'vuex'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {
    Snackbar,
    Loading
  },
  data() {
    return {
      contador: 5,
      fullPage: true,
      isLoading: false,
      exibeSenhaAtual: false,
      exibeSenhaNova: false,
      exibeSenhaRepeticao: false,
      financialManager: [],
      tempPassword: false,
      dialog: false,
      rowsPerPageItems: [1, 12, 18],
      pagination: {
        rowsPerPage: 1
      },
      showAlterPass: false,
      email: '',
      password: '',
      resetPassword: '',
      confirmPassword: '',
      activeBtn: 'Propostas',
      nomeUsuario: '',
      proposta: [],
      propostaPendente: false,
      propostas: false,
      boletos: false,
      carteirinha: false,
      dictionary: {
        custom: {
          password: {
            required: () => 'Informe a Senha',
            confirmed: () => 'A senha não confere'
          },
          senha: {
            required: () => 'Informe a Senha'
          },
          senhaAtual: {
            required: () => 'Informe a Senha'
          }

        }
      }
    }
  },
  computed: mapState({
    userloggedin: state => state.userloggedin,
  }),
  mounted: function () {
    setInterval(() => {
      this.contador--
    }, 1000)
    setTimeout(() => {
      this.$router.push({
        path: '/areacliente'
      })
    }, 5000)

  },
  methods: {

  }

}
</script>

<style>
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border-radius: 10px;
}

.informativo {
  font-size: 25px;
  color: #009b9b;
  ;
  line-height: 30px;
  margin-top: 5px;
  display: block;
  font-weight: bold;
}
</style>
